module.exports = __webpack_public_path__ + "static/media/shadow-phone.660ab39d.svg";